import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  children: React.ReactNode;
  className?: string;
}
export function SectionHeading({
  eyebrow,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-211" data-mp="3f25cf5v46ml7">
      {eyebrow && <p className="mb-3 text-xs font-semibold uppercase tracking-[0.25em] text-[var(--rose)]" data-id="element-212" data-mp="3jzx7g8r22otm">
          {eyebrow}
        </p>}
      <h2 className="font-serif-display text-3xl font-bold leading-tight text-[var(--text)] sm:text-4xl md:text-5xl" data-id="element-213" data-mp="blohl8fx4c55">
        {children}
      </h2>
    </div>;
}